import React from 'react'
import HouseInShape from '@shared/svg/in-shape/house.svg'
import ShieldInShape from '@shared/svg/in-shape/shield.svg'
import RubInShape from '@shared/svg/in-shape/rub.svg'
import ValtInShape from '@shared/svg/in-shape/valt.svg'

import styles from './style.module.scss'

const autoPoints = [
	{
		IconSvg: ShieldInShape,
		text: 'Официальный кредитор. Не являемся автоломбардом и кредитным брокером',
	},
	{
		IconSvg: RubInShape,
		text: 'ЦБ РФ осуществляет надзор в соответствии с законодательством',
	},
	{
		IconSvg: HouseInShape,
		text: 'Вы остаётесь собственником авто и сможете использовать так же, как и раньше',
	},
]

const mainPoints = [
	{
		IconSvg: ShieldInShape,
		text: 'Работаем в строгом соответствии с Федеральным законом № 102-ФЗ «Об ипотеке (залоге недвижимости)»',
	},
	{
		IconSvg: RubInShape,
		text: 'ЦБ РФ осуществляет надзор в соответствии с законодательством',
	},
	{
		IconSvg: HouseInShape,
		text: 'Вы остаётесь собственником квартиры, поэтому никого не нужно выписывать',
	},
]

const ipotekaPoints = [
	{
		IconSvg: ShieldInShape,
		text: 'Официальный кредитор',
	},
	{
		IconSvg: RubInShape,
		text: 'ЦБ РФ осуществляет надзор в соответствии с законодательством',
	},
	{
		IconSvg: ValtInShape,
		text: 'Без скрытых платежей и комиссий',
	},
]

interface ViewProps {
	isAutoLoan?: boolean
	isIpoteka?: boolean | undefined
}

export const View = ({ isAutoLoan = false, isIpoteka }: ViewProps) => {
	let points = isAutoLoan ? autoPoints : mainPoints
	if (isIpoteka) {
		points = ipotekaPoints
	}

	return (
		<div className={styles.points}>
			{points.map(({ IconSvg, text }) => (
				<div className={styles.point} key={text}>
					<div className={styles.icon}>
						<IconSvg />
					</div>
					<div className={styles.pointSummary}>
						<div className={styles.pointSummaryText}>{text}</div>
					</div>
				</div>
			))}
		</div>
	)
}
